
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('lc-cart-overlay');
  if (!drawer) return;

  const content = drawer.querySelector('#lc-cart-content');
  const panel = drawer.querySelector('.lc-cart-panel');

  const money = cents => {
    return '₹' + Math.round(cents / 100).toLocaleString('en-IN');
  };

  const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, c => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  })[c]);

  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  async function getCart() {
    const response = await fetch('/cart.js', {
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  function renderCart(cart) {
    if (!cart.item_count) {
      content.innerHTML = `
        <div class="lc-cart-empty">
          <div class="lc-cart-icon">🛒</div>
          <h2>Your Cart Is Empty</h2>
          <a href="/collections/all" class="lc-cart-continue">CONTINUE SHOPPING</a>
        </div>`;
      return;
    }

    content.innerHTML = `
      <div class="lc-cart-filled">
        <h2>Your Cart (${cart.item_count})</h2>
        <div class="lc-cart-filled-items">
          ${cart.items.map((item, index) => `
            <div class="lc-cart-product" data-key="${escapeHTML(item.key)}">
              <a href="${escapeHTML(item.url)}" class="lc-cart-product-image">
                ${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" loading="lazy">` : ''}
              </a>
              <div class="lc-cart-product-info">
                <a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>
                ${item.variant_title && item.variant_title !== 'Default Title' ? `<p>${escapeHTML(item.variant_title)}</p>` : ''}
                <p class="lc-item-price">${money(item.final_line_price)}</p>
                <div class="lc-quantity-controls">
                  <button type="button" class="lc-qty-minus" data-line="${index + 1}" aria-label="Decrease quantity">−</button>
                  <span class="lc-qty-value">${item.quantity}</span>
                  <button type="button" class="lc-qty-plus" data-line="${index + 1}" aria-label="Increase quantity">+</button>
                  <button type="button" class="lc-remove-item" data-line="${index + 1}" aria-label="Remove product">×</button>
                </div>
              </div>
            </div>
          `).join('')}
        </div>
        <div class="lc-cart-summary-line"></div>

<div class="lc-cart-total-row">
  <strong>Total: ${money(cart.total_price)}</strong>
  <span class="lc-free-shipping">
  <span class="lc-truck">🚚</span> Free Shipping
</span>
</div>

<a href="/checkout" class="lc-cart-checkout">

  <div class="lc-checkout-left">
    <span class="lc-checkout-title">Checkout Now →</span>
    <span class="lc-checkout-offer">Extra 5% off on Prepaid Order</span>
  </div>

  <div class="lc-checkout-right">
  <img src="https://cdn.shopify.com/s/files/1/0682/4538/9400/files/Gpay.png?v=1793352225" alt="GPay">
  <img src="https://cdn.shopify.com/s/files/1/0682/4538/9400/files/Paytm.png?v=1793352225" alt="Paytm">
  <img src="https://cdn.shopify.com/s/files/1/0682/4538/9400/files/PhoneP.png?v=1793352224" alt="PhonePe">
  <img src="https://cdn.shopify.com/s/files/1/0682/4538/9400/files/COD.png?v=1793352225" alt="COD">
</div>
</a>

<div class="lc-cart-secure-line">
  100% Secure Payment | COD Available.
</div>

</div>`;
  }

  async function refreshCart() {
    const cart = await getCart();
    renderCart(cart);
    return cart;
  }

  async function changeQuantity(line, quantity) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    });

    if (!response.ok) throw new Error('Could not update quantity');
    const cart = await response.json();
    renderCart(cart);
  }

  document.addEventListener('click', async function (event) {
    const close = event.target.closest('.lc-cart-close');
    if (close && drawer.contains(close)) {
      closeDrawer();
      return;
    }

    if (event.target === drawer) {
      closeDrawer();
      return;
    }

    const add = event.target.closest('.lc-cart-add');

if (add && drawer.contains(add)) {
  if (add.disabled) return;

  add.disabled = true;
  const originalText = add.textContent;
  add.textContent = '✓';

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        id: Number(add.dataset.variantId),
        quantity: 1
      })
    });

    if (!response.ok) throw new Error('Add to cart failed');

    await refreshCart();

  } catch (error) {
    console.error(error);
    add.textContent = originalText;
    add.disabled = false;
    alert('Product add nahi hua. Dobara try karein.');
  }

  return;
}

    const minus = event.target.closest('.lc-qty-minus');
    const plus = event.target.closest('.lc-qty-plus');
    const remove = event.target.closest('.lc-remove-item');

    if (minus || plus || remove) {
      const button = minus || plus || remove;
      const line = Number(button.dataset.line);
      const row = button.closest('.lc-cart-product');
      const current = Number(row.querySelector('.lc-qty-value').textContent);
      const quantity = remove ? 0 : (plus ? current + 1 : Math.max(0, current - 1));

      button.disabled = true;
      try {
        await changeQuantity(line, quantity);
      } catch (error) {
        console.error(error);
        alert('Cart update nahi hua. Dobara try karein.');
        await refreshCart();
      }
      return;
    }

    const trigger = event.target.closest(
      'a[href="/cart"], a[href^="/cart?"], .cart-widget-side-trigger, .cart-icon'
    );

    if (trigger && !drawer.contains(trigger)) {
      event.preventDefault();
      try {
        await refreshCart();
        openDrawer();
      } catch (error) {
        console.error(error);
        openDrawer();
      }
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeDrawer();
  });
});
